export const AppDirDisplay = 'AppDirDisplay'
export const AppDirBegin = 'AppDirBegin'

export const getAppPenLabel = () => `cta=Switch to the app`

export const getSrpAppPenLabel = (categoryId: number) =>
  `cta=Switch to the app; catId=${categoryId}`
